var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.06,
    height: 10.374,
    viewBox: "0 0 12.06 10.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "double-arrow",
    transform: "translate(-347.94 -219.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M9.547,6.014a.825.825,0,0,1-.585-.242L5.187,2,1.412,5.772A.827.827,0,0,1,.242,4.6L4.6.242a.827.827,0,0,1,1.17,0L10.132,4.6a.827.827,0,0,1-.585,1.412Z",
    transform: "translate(353.954 219.863) rotate(90)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M9.547,6.014a.825.825,0,0,1-.585-.242L5.187,2,1.412,5.772A.827.827,0,0,1,.242,4.6L4.6.242a.827.827,0,0,1,1.17,0L10.132,4.6a.827.827,0,0,1-.585,1.412Z",
    transform: "translate(360 219.863) rotate(90)",
    fill: "#9a9a9a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDoubleArrow);
export default __webpack_public_path__ + "static/media/right-double-arrow.7a87da92.svg";
export { ForwardRef as ReactComponent };